import React from 'react';
import PropTypes from 'prop-types';
import HotelRoomCard, { RoomShape } from './HotelRoomCard';

const HotelRooms = ({ rooms = [] }) => {
  if (rooms.length === 0) {
    return null;
  }

  return (
    <div className="margin-2-t">
      {rooms.map((room, index) => (
        <HotelRoomCard
          key={room.id}
          room={room}
          isLast={index === rooms.length - 1}
        />
      ))}
    </div>
  );
};

HotelRooms.propTypes = {
  rooms: PropTypes.arrayOf(RoomShape),
};

export default HotelRooms;
